import type { RoleUser } from "@/graphql/codegen/graphql"

export const formatRoleUserInfo = (users: RoleUser[]): string => {
  return users?.map((user) => `[${user.name}]`).join(" ") ?? ""
}
